import AboutHero from "src/sections/about/about-hero"
import AboutWhat from "src/sections/about/about-what2"

const PrivacyPolicyView = () => {
    // let { data } = useGetPrivacyPolicyQuery({ language: currentLang.value });
    return (
        <div>
            <AboutHero data={{ title: "Our", list: ["Privacy policy"] }} />
            <AboutWhat data={{ title: "", content: data, image: '/assets/privacy-policy.jpeg' }} />
        </div>
    )
}

export default PrivacyPolicyView

const data = `
<h1>Privacy Policy</h1>

<p>
At <strong>Drive Hub</strong>, your privacy is our top priority. This Privacy Policy explains how we collect, use, and protect your personal information when you use our platform to manage your rides, earnings, and performance data from services such as Uber, Lyft, and DoorDash.
</p>

<h2>1. Information We Collect</h2>
<p>
We collect the following types of information to provide you with a seamless experience:
</p>
<ul>
  <li><strong>Personal Information:</strong> Name, phone number, email address, and account credentials used for registration and login.</li>
  <li><strong>Vehicle Details:</strong> Vehicle name, model, and related data for performance tracking.</li>
  <li><strong>Trip Data:</strong> Trip date, time, distance, fare, platform used (Uber, Lyft, DoorDash), location, and status.</li>
  <li><strong>Performance and Earnings:</strong> Information related to your per-mile and per-hour rates, total trips, and earnings over specific periods.</li>
  <li><strong>Device and Usage Data:</strong> IP address, browser type, device information, and interaction logs to improve app performance and security.</li>
</ul>

<h2>2. How We Use Your Information</h2>
<p>
Drive Hub uses the collected data for the following purposes:
</p>
<ul>
  <li>To provide, operate, and improve the Drive Hub platform and its features.</li>
  <li>To calculate and display your trip statistics, earnings, and performance metrics.</li>
  <li>To personalize your dashboard and enhance the user experience.</li>
  <li>To send important notifications, updates, and support responses.</li>
  <li>To ensure compliance with legal requirements and protect against fraudulent or unauthorized activities.</li>
</ul>

<h2>3. Data Security</h2>
<p>
We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.
All data is transmitted over secure HTTPS connections and stored using encrypted databases and restricted access protocols.
</p>

<h2>4. Data Sharing</h2>
<p>
We do <strong>not</strong> sell, trade, or rent users’ personal information to others. Data may be shared only in the following cases:
</p>
<ul>
  <li>With your consent, when you choose to link or sync data from external rideshare platforms.</li>
  <li>With service providers who help operate the Drive Hub platform under strict confidentiality agreements.</li>
  <li>When required by law, to comply with legal processes or protect our users and platform integrity.</li>
</ul>

<h2>5. Cookies and Tracking Technologies</h2>
<p>
Drive Hub uses cookies and similar technologies to improve user experience, remember preferences, and analyze site performance.
You can choose to disable cookies in your browser settings, but some features may not function properly as a result.
</p>

<h2>6. Data Retention</h2>
<p>
Your information is retained as long as your account remains active or as needed to provide our services.
If you close your account, your personal data will be securely deleted in accordance with our data retention policies.
</p>

<h2>7. Your Rights</h2>
<p>
You have the right to:
</p>
<ul>
  <li>Access and review the information we store about you.</li>
  <li>Update or correct your personal details through your profile settings.</li>
  <li>Request deletion of your account and associated data.</li>
  <li>Opt out of receiving promotional communications at any time.</li>
</ul>

<h2>8. Updates to This Policy</h2>
<p>
We may update this Privacy Policy periodically to reflect changes in our practices or for other operational, legal, or regulatory reasons.
You will be notified of significant updates through in-app notifications or email.
</p>

<h2>9. Contact Us</h2>
<p>
If you have any questions about this Privacy Policy or how your data is handled, please contact our support team at
<a href="mailto:support@drivehub.com">support@drivehub.com</a>.
</p>
`;
